/**
 * Dachtyp-Switch auf der Unterkonstruktion-Collection-Seite.
 * Schaltet Panels für Schrägdach / Flachdach ohne Seitenreload.
 */
(function () {
  function syncButtons(root, activeKey) {
    root.querySelectorAll('[data-roof-switch]').forEach(function (button) {
      var isActive = button.getAttribute('data-roof-switch') === activeKey;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });
  }

  function activatePanel(root, panelKey) {
    var panels = root.querySelectorAll('[data-roof-panel]');

    panels.forEach(function (panel) {
      var match = panel.getAttribute('data-roof-panel') === panelKey;
      if (match) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    syncButtons(root, panelKey);
  }

  function init(root) {
    var buttons = root.querySelectorAll('[data-roof-switch]');
    if (!buttons.length) return;

    var defaultKey = root.getAttribute('data-roof-default') || 'schragdach';
    activatePanel(root, defaultKey);

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var panelKey = this.getAttribute('data-roof-switch');
        if (panelKey) {
          activatePanel(root, panelKey);
        }
      });
    });
  }

  document.querySelectorAll('[data-collection-roof-filter]').forEach(init);
})();
